import { render } from "./DialogIssueExternalCouponFail.vue?vue&type=template&id=08351f4e&scoped=true"
import script from "./DialogIssueExternalCouponFail.vue?vue&type=script&lang=js"
export * from "./DialogIssueExternalCouponFail.vue?vue&type=script&lang=js"

import "./DialogIssueExternalCouponFail.vue?vue&type=style&index=0&id=08351f4e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-08351f4e"

export default script